import type {PerkUsagePreviewComponentProps} from '@cohort/merchants/apps';
import {Fragment} from 'react';

export const CohortQrCodePerkIntegrationsUsagePreviewComponent: React.FC<
  PerkUsagePreviewComponentProps
> = () => {
  return <Fragment />;
};
